import React from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import CreatePassword from "../../components/CreatePassword";

const CreatePasswordScreen = (props) => {
  return (
    <HeaderDrawer name="Criar senha">
      <CreatePassword
        {...props}
        onRequestSend={(values, token) =>
          props.createInitialPassword(values, token)
        }
        token={props.token}
      />
    </HeaderDrawer>
  );
};

export default CreatePasswordScreen;
